import { StarbaseEntity, Serializable } from 'starbase-launcher';
import { IColumnModel, ColumnModel } from 'table-editor';

export class RsSequenceUpdate {

    public relatedSetUID: number;
    
    public relatedSetName: string;

    public imageUIDs: number[];
    
    deserialize(input) {
        return Object.assign(new RsSequenceUpdate(), input);
    }
}
